module.exports = __webpack_public_path__ + "img/psychologist.d972c82c.png";